"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DTOHash = void 0;
const sha256_1 = require("@noble/hashes/sha256");
const utils_1 = require("@noble/hashes/utils");
const json_stringify_deterministic_1 = __importDefault(require("json-stringify-deterministic"));
class DTOHash {
    get prev() {
        return this.previousHash;
    }
    makeId(dto) {
        return __awaiter(this, void 0, void 0, function* () {
            const hashRecord = dto;
            const thisHash = yield this.hashObject(hashRecord);
            this.previousHash = thisHash;
            return thisHash;
        });
    }
    hashObject(obj) {
        return __awaiter(this, void 0, void 0, function* () {
            const deterministic = (0, json_stringify_deterministic_1.default)(obj);
            const hash = (0, sha256_1.sha256)(deterministic);
            return (0, utils_1.bytesToHex)(hash);
        });
    }
}
exports.DTOHash = DTOHash;
